export default __webpack_public_path__ + "static/media/logo.b0dece73.svg";